import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, createFormData } from "./InstallationFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import { validate } from "../../../custom/validations/Validate";
import {
  dropdownData,
  getRecords,
  saveRecords,
  formatNumber,
} from "../../../services/api.service";
import { toast } from "react-toastify";
import NumberInput from "../../../custom/components/Number-Input/NumberInput";

const InstallationCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(createFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [customerSelectOptions, setCustomerSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [fetchedData, setFetchedData] = useState(null);

  const [projectSelect, setProjectSelect] = useState("");
  const [projectSelectOptions, setProjectSelectOptions] = useState([]);

  //new
  const [itemSelectOptions, setItemSelectOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedFilteredItems, setSelectedFilteredItems] = useState([]);
  const [filteredOptionsWithoutSelected, setFilteredOptionsWithoutSelected] =
    useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };

  useEffect(() => {
    setFilteredOptions(
      itemSelectOptions[0]?.options.filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) =>
              (selected?.item_code && selected?.item_code == option?.label) ||
              (selected?.label && selected?.label == option?.label),
          ),
      ),
    );
  }, [itemSelectOptions]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const loginUserId = JSON.parse(localStorage.getItem("userDetails"))?.id;
    if (id) {
      getEditData(id, loginUserId);
      // getItemDropData();
    } else {
      getProjectDropData();
      getUserMasterDropData();
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;

      // Transform list_details
      const updatedListDetails = data?.list_details?.reduce((acc, item) => {
        // Determine the type based on is_make_item
        const type = item.is_make_item ? 1 : 2;

        // If it's a make_item (type === 1), group buy_item_details
        if (type === 1) {
          // Check if the make_item already exists in the accumulator
          const existingMakeItemIndex = acc.findIndex(
            (i) => i.item_id === item.item_id && i.type === 1,
          );

          if (existingMakeItemIndex !== -1) {
            // If the make_item already exists, add the buy_item to its buy_item_details
            acc[existingMakeItemIndex].buy_item_details.push({
              buy_item_id: item.buy_item_id,
              buy_item_code: item.buy_item_code,
              buy_item_desc: item.buy_item_desc,
              qty: parseFloat(item.qty),
              qty_per_piece: parseFloat(item?.qty_per_piece),
              uom: item.uom,
              is_active: item.is_active,
            });
          } else {
            // If the make_item does not exist, create a new entry
            acc.push({
              id: item.id,
              item_id: item.item_id,
              item_code: item.item_code,
              item_desc: item.item_desc,
              uom: item.uom,
              qty: parseFloat(item.qty),
              qty_per_piece: parseFloat(item.qty_per_piece),
              make_item_qty: parseFloat(item.make_item_qty),

              is_active: item.is_active,
              type: 1,
              buy_item_details: [
                {
                  buy_item_id: item.buy_item_id,
                  buy_item_code: item.buy_item_code,
                  buy_item_desc: item.buy_item_desc,
                  qty: parseFloat(item.qty),
                  qty_per_piece: parseFloat(item.qty_per_piece),
                  uom: item.uom,
                  is_active: item.is_active,
                },
              ],
            });
          }
        } else {
          // If it's not a make_item (type === 2), add it as is
          acc.push({
            id: item.id,
            item_id: item.item_id,
            item_code: item.item_code,
            item_desc: item.item_desc,
            buy_item_id: item.buy_item_id,
            buy_item_code: item.buy_item_code,
            buy_item_desc: item.buy_item_desc,
            uom: item.uom,
            qty: parseFloat(item.qty),
            qty_per_piece: parseFloat(item.qty_per_piece),
            make_item_qty: parseFloat(item.make_item_qty),
            is_active: item.is_active,
            type: 2,
          });
        }

        return acc;
      }, []);

      // Update formData with the transformed list_details
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          list_details: updatedListDetails,
        },
      }));
      const preSelected = updatedListDetails
        .filter((item) => item.is_active)
        .map((item) => ({
          label: item.item_code,
          value: item.item_id,
          item_code: item.item_code,
          id: item.item_id,
        }));

      setSelectedFilteredItems(preSelected);
    }
  }, [fetchedData]);

  const getEditData = async (id, loginUserId) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
        getProjectDropData(data?.project_id);
        getUserMasterDropData(data?.customer_id);
        getItemDropData(data?.project_id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getProjectDropData = async (projectId) => {
    try {
      const user_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

      let payload = {
        modelName: "projects",
        relations: [
          {
            module: "project_access",
            moduleAs: "project_access",
            isModuleWhereConditionRequired: true,
            required: true,
          },
        ],
        whereCondition: {
          is_active: true,
        },
        moduleWhereCondition: {
          user_id: user_id,
          access: true,
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/listProject");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "project_name",
        );
        if (id) {
          dropdownResponseData[0].options.forEach((element) => {
            if (element.value == projectId) {
              setProjectSelect(element);
            }
          });
        }
        setProjectSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getItemDropData = async (projectId) => {
    try {
      let payload = {
        project_id: projectId || projectSelect?.value,
      };
      const responseData = await getRecords(
        payload,
        "/getInstallationItemMaster",
      );

      if (responseData.data && responseData.data.length > 0) {
        const transformedData = responseData.data?.map((item) => ({
          ...item,
          id: item.item_id,
        }));

        const dropdownResponseData = await dropdownData(
          transformedData,
          "item_code",
        );

        setFilteredOptions(dropdownResponseData);
        setItemSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getUserMasterDropData = async (customerId) => {
    try {
      let payload = {
        modelName: "company_masters",
        whereCondition: { type: 2, is_active: true },
      };

      const responseData = await getRecords(payload, "/listCustomers");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "company_name",
        );
        if (id) {
          dropdownResponseData[0].options.forEach((element) => {
            if (element.value == customerId) {
              setCustomerSelect(element);
            }
          });
        }
        setCustomerSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = validate(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? 1 : 0) : value,
      },
    }));
  };

  const handleCustomerSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      customer_id: selectedValue,
    });

    setCustomerSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      customer_id: fieldError?.customer_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        customer_id: selectedValue,
      },
    }));
  };

  const handleProjectSelect = (options) => {
    setSelectedFilteredItems([]);
    const selectedValue = options ? options.value : "";
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        list_details: [],
      },
    }));
    const fieldError = validate(validationType, {
      project_id: selectedValue,
    });

    setProjectSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      project_id: fieldError?.project_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        project_id: selectedValue,
      },
    }));
    if (selectedValue) {
      getItemDropData(selectedValue);
    } else {
      getItemDropData();
    }
  };

  const getItemMasterByIdData = async (Id, index) => {
    try {
      const matchedData = filteredOptions
        ?.flatMap((option) => option.data)
        ?.find((item) => item.item_id === Id);

      if (matchedData) {
        setFormData((prev) => {
          const updatedDetails = [...prev.inputData.list_details];

          // Check if the item already exists in the list with is_active: false
          const existingInactiveItemIndex = updatedDetails.findIndex(
            (item) =>
              item.item_id === matchedData.item_id && item.is_active == false,
          );

          if (existingInactiveItemIndex !== -1) {
            // If the item exists and is inactive, update its is_active to true and reuse the data
            updatedDetails[existingInactiveItemIndex] = {
              ...updatedDetails[existingInactiveItemIndex],
              is_active: true, // Set is_active to true
              make_item_qty: "", // Reset make_item_qty
            };
          } else {
            // If the item does not exist or is already active, add it as a new entry
            const firstBuyItem = matchedData?.buyItem?.[0] || {};

            updatedDetails[index] = {
              ...updatedDetails[index],
              uniqueId: matchedData?.uniqueId,
              item_id: matchedData?.item_id || null,
              item_code: matchedData?.item_code || null,

              // Buy item properties with fallbacks
              buy_item_id: firstBuyItem?.item_id || null,
              buy_item_code: firstBuyItem?.item_code || null,
              buy_item_desc: firstBuyItem?.item_desc || null,
              qty: parseFloat(firstBuyItem?.bom_qty) || 0,
              qty_per_piece: parseFloat(firstBuyItem?.bom_qty) || 0,
              uom: firstBuyItem?.uom_name || null,

              type: matchedData?.type,
              make_item_qty: null,
              is_active: true, // Set is_active to true for new entries

              // Handle buy_item_details more safely
              ...(matchedData.type === 1 && {
                buy_item_details: (matchedData.buyItem || []).map(
                  (bomItem) => ({
                    buy_item_id: bomItem?.item_id || null,
                    buy_item_code: bomItem?.item_code || null,
                    buy_item_desc: bomItem?.item_desc || null,
                    qty: parseFloat(bomItem?.bom_qty) || 0,
                    qty_per_piece: parseFloat(bomItem?.bom_qty) || 0,
                    uom: bomItem?.uom_name || null,
                    is_active: true, // Set is_active to true for buy_item_details
                  }),
                ),
              }),
            };
          }

          return {
            ...prev,
            inputData: {
              ...prev.inputData,
              list_details: updatedDetails,
            },
          };
        });
      } else {
        console.warn(`No matching data found for ID: ${Id}`); // Better logging
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const getItemMasterByIdData = async (Id, index) => {
  //   try {
  //     const matchedData = filteredOptions?.flatMap((option) => option.data)?.find((item) => item.item_id === Id);

  //     if (matchedData) {
  //       setFormData((prev) => {
  //         const updatedDetails = [...prev.inputData.list_details];

  //         const firstBuyItem = matchedData?.buyItem?.[0] || {};

  //         updatedDetails[index] = {
  //           ...updatedDetails[index],
  //           uniqueId: matchedData?.uniqueId,
  //           item_id: matchedData?.item_id || null,
  //           item_code: matchedData?.item_code || null,

  //           // Buy item properties with fallbacks
  //           buy_item_id: firstBuyItem?.item_id || null,
  //           buy_item_code: firstBuyItem?.item_code || null,
  //           buy_item_desc: firstBuyItem?.item_desc || null,
  //           qty: parseFloat(firstBuyItem?.bom_qty) || 0,
  //           qty_per_piece: parseFloat(firstBuyItem?.bom_qty) || 0,
  //           uom: firstBuyItem?.uom_name || null,

  //           type: matchedData?.type,
  //           make_item_qty: null,
  //           is_active: matchedData?.is_active,

  //           // Handle buy_item_details more safely
  //           ...(matchedData.type === 1 && {
  //             buy_item_details: (matchedData.buyItem || []).map((bomItem) => ({
  //               buy_item_id: bomItem?.item_id || null,
  //               buy_item_code: bomItem?.item_code || null,
  //               buy_item_desc: bomItem?.item_desc || null,
  //               qty: parseFloat(bomItem?.bom_qty) || 0,
  //               qty_per_piece: parseFloat(bomItem?.bom_qty) || 0,
  //               uom: bomItem?.uom_name || null,
  //               is_active: bomItem?.is_active,
  //             })),
  //           }),
  //         };

  //         return {
  //           ...prev,
  //           inputData: {
  //             ...prev.inputData,
  //             list_details: updatedDetails,
  //           },
  //         };
  //       });
  //     } else {
  //       console.warn(`No matching data found for ID: ${Id}`); // Better logging
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const handleAddItem = async (data) => {
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      list_details: [],
    }));

    const match = itemSelectOptions[0]?.options[0]?.data.find(
      (item) => item.item_code.toLowerCase() === data.toLowerCase(),
    );

    if (!match) {
      toast.error("Item does not exist");
      return;
    }

    const isDuplicate = formData?.inputData?.list_details?.some(
      (item) => item.item_id == match?.id && item.is_active === true,
    );

    if (isDuplicate) {
      toast.error(
        "This item has already been added. Skipping duplicate entry.",
      );
      return;
    }

    let emptyRowIndex = formData?.inputData?.list_details.findIndex(
      (item) => !item.item_id,
    );

    if (emptyRowIndex != -1) {
      await getItemMasterByIdData(match.id, emptyRowIndex);
      setSelectedFilteredItems((prev) => [...prev, match]);

      toast.success(`The item "${match.item_code}" added successfully`);

      setTimeout(() => {
        document
          .getElementById("table-container")
          ?.scrollTo({ top: 9999, behavior: "smooth" });
      }, 100);
    } else {
      let index = formData?.inputData?.list_details?.length || 0;

      setSelectedFilteredItems((prev) => {
        const updatedArray = [...prev];
        updatedArray[index] = { label: match.item_code, value: match.id };
        return updatedArray;
      });
      await getItemMasterByIdData(match.id, index);
      toast.success(`The item "${match.item_code}" added successfully`);
      // setSelectedFilteredItems((prev) => [...prev, match]);

      setTimeout(() => {
        document
          .getElementById("table-container")
          ?.scrollTo({ top: 9999, behavior: "smooth" });
      }, 100);
    }
    setInputValue("");
    setFilteredOptions(
      itemSelectOptions[0]?.options.filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) =>
              (selected?.item_code && selected?.item_code == option?.label) ||
              (selected?.label && selected?.label == option?.label),
          ),
      ),
    );
  };

  const handleInputKeyDown = (e) => {
    setIsDropdownVisible(false);
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddItem(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const filteredData = itemSelectOptions[0].options
      .filter((option) =>
        option?.label?.toLowerCase().includes(value?.trim().toLowerCase()),
      )
      .filter(
        (option) =>
          !selectedFilteredItems.some(
            (selected) =>
              (selected?.item_code && selected?.item_code == option?.label) ||
              (selected?.label && selected?.label == option?.label),
          ),
      );

    setFilteredOptions(filteredData);
    setIsDropdownVisible(true);

    if (value === "") {
      setFilteredOptions(
        itemSelectOptions[0]?.options.filter(
          (option) =>
            !selectedFilteredItems.some(
              (selected) =>
                (selected?.item_code && selected?.item_code == option?.label) ||
                (selected?.label && selected?.label == option?.label),
            ),
        ),
      );
      setIsDropdownVisible(true);
    }
  };

  const handleItemDataSelect = async (item) => {
    if (!item || !item.label) {
      console.error("Invalid item selected:", item);
      return;
    }

    setInputValue(item.label);
    const data = item.label;
    setIsDropdownVisible(false);

    handleAddItem(data);
  };

  const handleRemoveListDetails = (item_id, index) => {
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors?.list_details) {
        delete updatedErrors.list_details[item_id];
      }
      return updatedErrors;
    });

    setSelectedFilteredItems((prevSelected) => {
      const updatedSelected = [...prevSelected];

      const itemIndex = prevSelected?.findIndex(
        (item) => item?.id == item_id || item?.value == item_id,
      );

      if (itemIndex !== -1) {
        updatedSelected[itemIndex] = undefined;
      }

      setFilteredOptions((prevOptions) => {
        const newOptions = itemSelectOptions[0]?.options.filter(
          (option) =>
            !updatedSelected.some(
              (selected) =>
                (selected?.item_code && selected?.item_code == option?.label) ||
                (selected?.label && selected?.label == option?.label),
            ),
        );

        if (
          prevSelected[itemIndex] &&
          !newOptions.some(
            (opt) =>
              opt.label === prevSelected[itemIndex]?.item_code ||
              opt.label === prevSelected[itemIndex]?.label,
          )
        ) {
          return [...newOptions, prevSelected[itemIndex]];
        }

        return newOptions;
      });

      return updatedSelected;
    });

    setFormData((prev) => {
      const updatedDetails = prev.inputData.list_details
        ?.filter((active) => active?.is_active == true)
        ?.map((item) =>
          item.item_id == item_id
            ? {
                ...item,
                is_active: false,
                make_item_qty: "",
                qty: 0,
                buy_item_details: item?.buy_item_details?.map((buyItem) => ({
                  ...buyItem,
                  qty: 0, // Reset buy item qty
                })),
              }
            : item,
        );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          list_details: updatedDetails,
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const validationErrors = validate(validationType, formData.inputData);
      const combinedErrors = { ...validationErrors };

      if (formData?.inputData?.list_details.length == 0) {
        toast.error("Please add item first.");
        return;
      }
      const listErrors = {};
      formData?.inputData?.list_details?.forEach((row, index) => {
        if (row.is_active == true) {
          ["make_item_qty"].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              if (!listErrors.list_details) listErrors.list_details = {};
              listErrors.list_details[index] = {
                ...listErrors.list_details[index],
                [field]: `${field
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) =>
                    char?.toUpperCase(),
                  )} is required`,
              };
            }
          });
        }
      });

      if (Object.keys(listErrors.list_details || {}).length > 0) {
        combinedErrors.list_details = {
          ...combinedErrors.list_details,
          ...listErrors.list_details,
        };
      }

      if (Object.keys(combinedErrors).length > 0) {
        setLoadingData(false);
        setFormErrors(combinedErrors);
        return;
      }

      const transformItem = (item, index) => {
        // Common base for all items
        const base = {
          id: item?.id,
          is_make_item: item?.type === 1,
          item_id: item?.item_id,
          item_code: item?.item_code || item?.buy_item_code,
          item_desc: item?.buy_item_desc,
          make_item_qty: item?.make_item_qty,
          is_active: item?.is_active,
          uom: item?.uom,
        };

        // Handle Type 2 (single item)
        if (item.type === 2) {
          return {
            ...base,
            buy_item_id: item?.buy_item_id,
            buy_item_code: item?.buy_item_code,
            buy_item_desc: item?.buy_item_desc,
            qty: parseFloat(item?.make_item_qty) || 0,
            qty_per_piece: parseFloat(item?.qty_per_piece) || 0,
          };
        }

        // Handle Type 1 (multiple buy items)
        if (item.type === 1 && item.buy_item_details) {
          return item.buy_item_details.map((buyItem) => ({
            ...base,
            item_code: item?.item_code,
            buy_item_id: buyItem?.buy_item_id,
            buy_item_code: buyItem?.buy_item_code,
            buy_item_desc: buyItem?.buy_item_desc,
            qty: parseFloat(buyItem?.qty) || 0,
            item_desc: buyItem?.buy_item_desc,
            qty_per_piece: parseFloat(buyItem?.qty_per_piece) || 0,
          }));
        }

        return base;
      };

      let transformedInputData = {
        form_name: formData?.inputData?.form_name || null,
        po_number: formData?.inputData?.po_number || null,
        ref_document_no: formData?.inputData?.ref_document_no || null,
        is_active: formData?.inputData?.is_active ?? true,
        project_id: formData?.inputData?.project_id || null,
        customer_id: formData?.inputData?.customer_id || null,
        list_details:
          formData?.inputData?.list_details
            ?.flatMap((item, index) => transformItem(item, index))
            ?.filter(Boolean) || [],
      };

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData?.inputData,
          ...transformedInputData,
        },
      };

      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`,
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  const toggleChildBuyItemDetail = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const filteredOptionsWithoutSelectedItems = filteredOptions?.filter(
      (item) =>
        !(selectedFilteredItems ?? []).some(
          (selected) =>
            selected?.item_code?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase() ||
            selected?.label?.toString().trim().toLowerCase() ==
              item?.label?.toString().trim().toLowerCase(),
        ),
    );
    setFilteredOptionsWithoutSelected(filteredOptionsWithoutSelectedItems);
  }, [filteredOptions, selectedFilteredItems]);
  const handleMakeQTYChange = (value, index, field, row) => {
    let error = null;
    let numericValue = value.trim() === "" ? "" : parseFloat(value);

    if (field === "make_item_qty") {
      if (value.trim() === "") {
        error = "Make Item Qty is required";
      } else if (isNaN(numericValue) || numericValue <= 0) {
        error = "Invalid qty";
      }
    }

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData.list_details];
      const activeDetails = updatedDetails?.filter(
        (item) => item.is_active === true,
      );

      if (activeDetails[index]?.is_active === true) {
        activeDetails[index] = {
          ...activeDetails[index],
          [field]: numericValue,
        };

        if (activeDetails[index]?.type === 1) {
          activeDetails[index].buy_item_details = activeDetails[
            index
          ].buy_item_details.map((buyItem) => ({
            ...buyItem,
            qty: numericValue * (buyItem.qty_per_piece || 0),
          }));
        }

        if (activeDetails[index]?.type === 2) {
          activeDetails[index].qty =
            numericValue * (activeDetails[index]?.qty || 0);
        }
      }

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          list_details: activeDetails,
        },
      };
    });

    setFormErrors((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        list_details: {
          ...prevErrors.list_details,
          [index]: {
            ...prevErrors.list_details?.[index],
            [field]: error,
          },
        },
      };
      return newErrors;
    });
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="Project"
            value={projectSelect}
            options={projectSelectOptions}
            onSelect={(selected) => handleProjectSelect(selected)}
            placeholder="Select project"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.project_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="Customer"
            value={customerSelect}
            options={customerSelectOptions}
            onSelect={(selected) => handleCustomerSelect(selected)}
            placeholder="Select customer"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.customer_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Form Name"
            name="form_name"
            value={formData?.inputData?.form_name}
            onChange={onInputChange}
            placeholder="Form Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.form_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="PO Number"
            name="po_number"
            value={formData?.inputData?.po_number}
            onChange={onInputChange}
            placeholder="PO Number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.po_number}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Reference Document No"
            name="ref_document_no"
            value={formData?.inputData?.ref_document_no}
            onChange={onInputChange}
            placeholder="Reference document no"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.ref_document_no}
          />
        </Col>
      </Row>

      <Row className="mt-4 " style={{ position: "relative" }}>
        <Col className="responsive-flex">
          <div>
            <h6 className="h-6-heading">Form Details</h6>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div className="app-search d-flex d-lg-inline mt-0 w-25">
                <div className="position-relative">
                  <input
                    ref={inputRef}
                    id="itemCode"
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleInputKeyDown}
                    placeholder="Add item code..."
                    className="form-control ps-5"
                    autoComplete="off"
                    onFocus={() => {
                      setIsDropdownVisible(true);

                      if (inputValue) {
                        setFilteredOptions(
                          itemSelectOptions[0].options
                            .filter((option) =>
                              option?.label
                                .toLowerCase()
                                .includes(inputValue?.trim().toLowerCase()),
                            )
                            .filter(
                              (option) =>
                                !selectedFilteredItems.some(
                                  (selected) =>
                                    (selected?.item_code &&
                                      selected?.item_code == option?.label) ||
                                    (selected?.label &&
                                      selected?.label == option?.label),
                                ),
                            ),
                        );
                      }
                    }}
                    style={{
                      width: "13rem",
                      padding: "8px 15px",
                      borderRadius: "8px",
                      borderColor: "#D2D2D2",
                      outline: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "none",
                      marginRight: "0.5rem",
                    }}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </div>

              {isDropdownVisible && (
                <div
                  ref={dropdownRef}
                  style={{
                    width: "13rem",
                    maxHeight: "150px",
                    overflowY: "auto",
                    border: "1px solid #D2D2D2",
                    borderRadius: "8px",
                    marginTop: "5px",
                    position: "absolute",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                    zIndex: "1000",
                  }}
                >
                  {filteredOptionsWithoutSelected &&
                  filteredOptionsWithoutSelected.length > 0 ? (
                    filteredOptionsWithoutSelected?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          handleItemDataSelect(item);
                        }}
                        style={{
                          padding: "8px 15px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f0f0f0")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        {item.label}
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        padding: "8px 15px",
                        cursor: "pointer",
                        borderBottom: "1px solid #f0f0f0",
                        textAlign: "center",
                        color: "gray",
                      }}
                    >
                      No Data..
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Col>

        <div
          className="table"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 40000,
              }}
            >
              <tr
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1050,
                  backgroundColor: "#8AC1E8",
                  borderBottom: "1px solid black",
                }}
              >
                <th style={{ whiteSpace: "nowrap" }}>Sr:No </th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Description</th>
                <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  QTY
                  <Asterisks asterisk={true} />
                </th>
                {/* Moved BOM QTY here */}
                <th style={{ whiteSpace: "nowrap" }} colSpan="3">
                  Actions
                </th>{" "}
                {/* Adjusted colspan */}
              </tr>
            </thead>
            <tbody>
              {formData?.inputData?.list_details &&
              formData?.inputData?.list_details?.length > 0 ? (
                formData?.inputData?.list_details
                  ?.filter((isDataActive) => isDataActive.is_active == true)
                  ?.map((row, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr style={{ borderBottom: "1px solid #cccccc" }}>
                          <td>{index + 1}</td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.item_code || "N/A"}
                            >
                              {row?.item_code || "N/A"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={
                                row?.type == 2
                                  ? row?.buy_item_desc || "N/A"
                                  : "-"
                              }
                            >
                              {row?.type == 2
                                ? row?.buy_item_desc || "N/A"
                                : "-"}
                            </div>
                          </td>

                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "100px",
                            }}
                          >
                            {row?.type == 2 ? row?.uom || "N/A" : "-"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "110px",
                            }}
                          >
                            <NumberInput
                              name="make_item_qty"
                              value={row?.make_item_qty}
                              onChange={(e) =>
                                handleMakeQTYChange(
                                  e.target.value,
                                  index,
                                  "make_item_qty",
                                  row,
                                )
                              }
                              placeholder="Enter qty"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              customError={
                                formErrors?.list_details?.[index]?.make_item_qty
                              }
                            />
                          </td>

                          {/* Actions Column */}
                          <td colSpan="3">
                            <div className="d-flex gap-3">
                              <div
                                onClick={() =>
                                  handleRemoveListDetails(row?.item_id, index)
                                }
                              >
                                <Link className="text-danger">
                                  <i className="mdi mdi-trash-can font-size-20"></i>
                                </Link>
                              </div>
                              {row?.type === 1 && (
                                <div
                                  color="info"
                                  onClick={() =>
                                    toggleChildBuyItemDetail(index)
                                  }
                                >
                                  {expandedRows[index] ? (
                                    <Link className="text-primary">
                                      <i className="mdi mdi-minus font-size-22"></i>
                                    </Link>
                                  ) : (
                                    <Link className="text-primary">
                                      <i className="mdi mdi-plus font-size-22"></i>
                                    </Link>
                                  )}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>

                        {expandedRows[index] && (
                          <>
                            {/* Sub Item Header */}
                            <tr
                              style={{
                                backgroundColor: "#d1ecf1",
                                fontWeight: "bold",
                              }}
                            >
                              <td></td>
                              <td>Buy Item Code</td>
                              <td>Buy Item Description</td>
                              <td>UOM</td>
                              <td>BOM QTY</td>
                              <td></td>
                              <td colSpan={3}></td>
                            </tr>
                            {row?.buy_item_details &&
                              row?.buy_item_details?.map(
                                (child, childIndex) => (
                                  <tr
                                    key={`${index}-${childIndex}`}
                                    style={{
                                      backgroundColor: "",
                                      borderBottom: "1px solid #cccccc",
                                    }}
                                  >
                                    <td>{`${index + 1}.${childIndex + 1}`}</td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                        minWidth: "180px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={child?.buy_item_code || "N/A"}
                                      >
                                        {child?.buy_item_code || "N/A"}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                        minWidth: "100px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={child?.buy_item_desc || "N/A"}
                                      >
                                        {child?.buy_item_desc || "N/A"}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                        minWidth: "110px",
                                      }}
                                    >
                                      {child?.uom}
                                    </td>
                                    <td
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      {formatNumber(child?.qty) || 0}
                                    </td>
                                    <td colSpan={3}></td>
                                  </tr>
                                ),
                              )}
                          </>
                        )}
                      </React.Fragment>
                    );
                  })
              ) : (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InstallationCreate;
